// @ts-nocheck
/**
 * Header trust verdict for the FinalMappingCard. Sits next to the
 * reconciliation status and answers, at a glance, the one question the whole
 * tie-out feature exists for: do the exported cell references actually resolve
 * to the values we mapped? Green when every line ties; red (and clickable to
 * the flagged rows) when any doesn't. Reuses the .fmc-status pill geometry.
 */
import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, Link2, Loader2 } from 'lucide-react';

const TrustBadge = ({ loading, error, summary, referencingAvailable, onJump }) => {
  if (loading) {
    return (
      <span className="fmc-status fmc-status-muted" aria-live="polite">
        <Loader2 size={12} className="fmc-spin" />
        <span>Checking tie-out</span>
      </span>
    );
  }

  // A hard error or nothing computed: stay quiet rather than alarm the user.
  if (error || !summary) return null;

  const total = summary.total || 0;
  const tied = summary.tie || 0;
  const flagged = summary.flag || 0;
  const sourceUnavailable = summary.source_unavailable || 0;

  // Cell-referencing didn't run (toggle off / CSV / source gone): neutral,
  // factual — never red. Red is reserved for genuine tie-out failures.
  if (referencingAvailable === false) {
    return (
      <button
        type="button"
        className="fmc-status fmc-status-muted fmc-status-btn"
        onClick={() => onJump?.('all')}
        title="View the tie-out ledger"
      >
        <Link2 size={12} />
        <span>Not cell-linked</span>
      </button>
    );
  }

  if (flagged > 0) {
    return (
      <button
        type="button"
        className="fmc-status fmc-status-bad fmc-status-btn"
        onClick={() => onJump?.('flagged')}
        title="Jump to the lines that need review"
      >
        <XCircle size={12} />
        <span>
          {flagged} {flagged === 1 ? 'line needs' : 'lines need'} review
        </span>
      </button>
    );
  }

  if (sourceUnavailable > 0 || tied < total) {
    return (
      <button
        type="button"
        className="fmc-status fmc-status-warn fmc-status-btn"
        onClick={() => onJump?.('all')}
        title="View the tie-out ledger"
      >
        <AlertTriangle size={12} />
        <span>
          {tied}/{total} linked
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      className="fmc-status fmc-status-good fmc-status-btn"
      onClick={() => onJump?.('all')}
      title="View the tie-out ledger"
    >
      <CheckCircle size={12} />
      <span>
        {tied}/{total} lines tie to source
      </span>
    </button>
  );
};

export default TrustBadge;
